<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'850px','max-width':'1100px','max-height':'720px'}">
       
        <MyTable :dataObj="dataObj"  :dataParams="{'communicateProtocol':editFormData.communicateProtocol}" :readOnly="true" :hideOperate="true" ></MyTable>
        

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import MyTable from '@/views/basicProduct/component/table.vue';
import {stringToJson} from '@/libs/tools.js'
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            editFormData:{
                type: Object,
                default: () => ({})
            }
        },
        name: "functemModel",
        components: {
            MyTable
        },
        data() {
            return {   
                loading:false,
                title: '',//弹框标题
                disabled:false,
                tableData:[],
                wordList:[],
                dataObj:{
                    loading:true,
                    pageId:'',
                    result:[]
                },
                isGener:true,
                hideOperate:true
            }
        },
        watch:{
            showModel(val){
                if(val){
                    this.getData()
                }
            },
        },
        computed:{
            local(){
                return this.$store.state.local
            },
            localLang(){
               let lang = this.local
               let obj = {'zh-CN':'CN','en-US':'EN'}
               let cur = obj[lang] || ''
               return cur
            }

        },
        methods: {
            getData(){//获取功能数据
            //    console.log(this.editFormData)
                this.dataObj.loading = true
                let id = this.editFormData.id 
                // let id = 188 
                this.axios.post(this.config.urlArray.functionList, {dealerProductTypeId:id}).then((result) => {
                    // common.ajaxMsg(result.data,true,false);
                     common.ajaxMsg(result.data,false,()=>{

                         let resData = result.data.data
                         //处理数组
                         this.dataObj.result  =  resData
                         this.dataObj.loading = false

      
                     },()=>{
                         this.dataObj.loading = false
                     })
                })
            },

            openOrClose(value) {
                if(value === true) {    
                    this.title = this.$t('productManage.functionModel.title')
                } else { //关闭弹框后要做的处理
                    // this.fn()
                }
            },
            cancel() {//对话框关闭
                this.disabled = false
                this.$emit('update:showModel',false);
            }
        }
    }
</script>
<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
}
/deep/ .ivu-table-fixed-body{
    height: 100% !important;
    max-height: 531px;
}
/deep/ .ivu-modal-body{
    text-align: center;
}
.goodsCon{
     flex-wrap: wrap;
      // overflow-y: scroll;
     overflow: auto;
     max-height: 500px;
     .goodsItemCon{
         width:46%;
         margin-left: 2%;
         margin-bottom: 20px;
     }
     .goodsItem{
        
         background-color: #fff;
         border: 2px solid #E5E5E5;
         border-radius: 10px;
         padding: 20px 30px;
        
         min-width: 193px;
         overflow-x: hidden;
         cursor: pointer;
         .imgCon{
             width: 120px;
             height: 120px;
             margin: 0 auto;
             img{
                 width: auto;
                 height: 100%;
                 max-width: calc(100% + 90px);
             }
         }
         .goodName{
             color: #3A464E;
             margin-top: 7px;
             text-align: center;
         }
         .bottomInfo{
             margin-top: 20px;
             color: #3A464E;
             text-align: center;
             line-height: normal;
             .desc{
                 font-size: 12px;
                 color: #A4B4BF;
                 margin-top: 15px;
             }
             .dataNum{
                 height: 26px;
                 line-height: 26px;
             }
             .numCon{
                font-size: 20px;
                font-family: Source Han Sans SC;
                font-weight: bold;
                color: #E76D6A;
             }
         }
     }
     .selectButton{
         margin-top: 10px;
         position: relative;
         left: 50%;
         transform: translateX(-50%);
     }
 }
</style>